/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Rv_ConsInputs */

const en_pc_rv_cons = /** @type {(inputs: Pc_Rv_ConsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What to expect`)
};

const zh_pc_rv_cons = /** @type {(inputs: Pc_Rv_ConsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`需要心理准备的`)
};

/**
* | output |
* | --- |
* | "What to expect" |
*
* @param {Pc_Rv_ConsInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_rv_cons = /** @type {((inputs?: Pc_Rv_ConsInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Rv_ConsInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_rv_cons(inputs)
	return zh_pc_rv_cons(inputs)
});
export { pc_rv_cons as "pc.rv.cons" }